import PreSaleContract from './pre-sale-contract.vue'
export default PreSaleContract
